module.exports = __webpack_public_path__ + "static/media/duck01c.217028a7.png";